import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'

export interface UpdatePurchaseProcessStatus {
    execute(
        id: string,
        status: PurchaseProcess['status']
    ): Promise<PurchaseProcess>
    getSource(): string
}

export class UpdatePurchaseProcessStatusUseCase
    implements UpdatePurchaseProcessStatus
{
    constructor(private repository: PurchasingRepository) {}
    async execute(
        id: string,
        status: PurchaseProcess['status']
    ): Promise<PurchaseProcess> {
        return this.repository.updateProcessStatus(id, { status })
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
